import React, { useState, useEffect } from 'react';

export default function UpdateClientModal({ client, onClose, onUpdateClient }) {
    const [formData, setFormData] = useState({
        id: client.id,
        nome: client.nome,
        telefone: client.telefone || '',
        email: client.email || '',
        rua: client.rua || '',
        bairro: client.bairro || '',
        cidade: client.cidade || '',
        estado: client.estado || '',
        cep: client.cep || '',
        cpf_cnpj: client.cpf_cnpj || '',  // Adicionando o campo CPF/CNPJ
    });

    const [errorMessages, setErrorMessages] = useState({
        nome: '',
        telefone: '',
        email: '',
        rua: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: '',
        cpf_cnpj: '',  // Validação do CPF/CNPJ
    });

    useEffect(() => {
        setFormData({
            id: client.id,
            nome: client.nome,
            telefone: client.telefone || '',
            email: client.email || '',
            rua: client.rua || '',
            bairro: client.bairro || '',
            cidade: client.cidade || '',
            estado: client.estado || '',
            cep: client.cep || '',
            cpf_cnpj: client.cpf_cnpj || '',  // Atualizando com o CPF/CNPJ
        });
    }, [client]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateForm = () => {
        let isValid = true;
        let newErrorMessages = {
            nome: '', telefone: '', email: '', rua: '', bairro: '', cidade: '', estado: '', cep: '', cpf_cnpj: ''
        };

        // Validação do nome
        if (!formData.nome.trim()) {
            newErrorMessages.nome = 'O nome é obrigatório.';
            isValid = false;
        }

        // Validação do telefone
        if (!formData.telefone.trim()) {
            newErrorMessages.telefone = 'O telefone é obrigatório.';
            isValid = false;
        }

        // Validação do email
        if (!formData.email.trim()) {
            newErrorMessages.email = 'O email é obrigatório.';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrorMessages.email = 'O email é inválido.';
            isValid = false;
        }

        // Validação da rua
        if (!formData.rua.trim()) {
            newErrorMessages.rua = 'A rua é obrigatória.';
            isValid = false;
        }

        // Validação do bairro
        if (!formData.bairro.trim()) {
            newErrorMessages.bairro = 'O bairro é obrigatório.';
            isValid = false;
        }

        // Validação da cidade
        if (!formData.cidade.trim()) {
            newErrorMessages.cidade = 'A cidade é obrigatória.';
            isValid = false;
        }

        // Validação do estado
        if (!formData.estado.trim()) {
            newErrorMessages.estado = 'O estado é obrigatório.';
            isValid = false;
        }

        // Validação do CEP
        if (!formData.cep.trim()) {
            newErrorMessages.cep = 'O CEP é obrigatório.';
            isValid = false;
        }

        // Validação do CPF/CNPJ
        if (!formData.cpf_cnpj.trim()) {
            newErrorMessages.cpf_cnpj = 'O CPF/CNPJ é obrigatório.';
            isValid = false;
        } else if (!/^\d{11}$/.test(formData.cpf_cnpj) && !/^\d{14}$/.test(formData.cpf_cnpj)) {
            newErrorMessages.cpf_cnpj = 'O CPF/CNPJ é inválido.';
            isValid = false;
        }

        setErrorMessages(newErrorMessages);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Valida os campos antes de enviar
        if (validateForm()) {
            // Atualiza os dados do cliente
            onUpdateClient(formData);
            onClose(); // Fechar o modal após o envio bem-sucedido
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="glass-panel p-6 w-full max-w-2xl text-white w-96">
                <h2 className="text-xl font-bold text-white mb-6 tracking-wide">Atualizar Cliente</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Nome</label>
                        <input
                            type="text"
                            name="nome"
                            value={formData.nome}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.nome ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.nome && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.nome}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">CPF/CNPJ</label>
                        <input
                            type="text"
                            name="cpf_cnpj"
                            value={formData.cpf_cnpj}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.cpf_cnpj ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.cpf_cnpj && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.cpf_cnpj}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Telefone</label>
                        <input
                            type="text"
                            name="telefone"
                            value={formData.telefone}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.telefone ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.telefone && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.telefone}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.email ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.email && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.email}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Rua</label>
                        <input
                            type="text"
                            name="rua"
                            value={formData.rua}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.rua ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.rua && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.rua}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Bairro</label>
                        <input
                            type="text"
                            name="bairro"
                            value={formData.bairro}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.bairro ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.bairro && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.bairro}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Cidade</label>
                        <input
                            type="text"
                            name="cidade"
                            value={formData.cidade}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.cidade ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.cidade && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.cidade}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Estado</label>
                        <input
                            type="text"
                            name="estado"
                            value={formData.estado}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.estado ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.estado && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.estado}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">CEP</label>
                        <input
                            type="text"
                            name="cep"
                            value={formData.cep}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.cep ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.cep && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.cep}</p>
                        )}
                    </div>

                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                        >
                            Atualizar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
